import { render, staticRenderFns } from "./Diagnosticos.vue?vue&type=template&id=12f0776c&lang=pug"
import script from "./Diagnosticos.vue?vue&type=script&lang=js"
export * from "./Diagnosticos.vue?vue&type=script&lang=js"
import style0 from "./Diagnosticos.vue?vue&type=style&index=0&id=12f0776c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports